module.exports = __webpack_public_path__ + "img/thumbnail_BrazillianSalmonPinkTarantula.4807a524.png";